const DeviceList = () => import('Views/device/device-list');
const DeviceAddEdit = () => import('Views/device/device-addEdit');
const DeviceDetail = () => import('Views/device/device-detail');
const DeviceAlarm = () => import('Views/device/device-alarm');
const DeviceBatchAlarm = () => import('Views/device/device-batch-alarm');
const DeviceMaintenance = () => import('Views/device/device-maintenance');
const DeviceCalibration = () => import('Views/device/device-calibration');
const DeviceDataChart = () => import('Views/device/deviceData-chart');
const DeviceMonitor = () => import('Views/device/device-monitor');

export default[
  { path: '/device-list', component: DeviceList },
  { path: '/device-add', component: DeviceAddEdit },
  { path: '/device-edit/:id', component: DeviceAddEdit },
  { path: '/device-detail/:id', component: DeviceDetail },
  { path: '/device-alarm/:id', component: DeviceAlarm },
  { path: '/device-batch-alarm', component: DeviceBatchAlarm },
  { path: '/device-maintenance/:id', component: DeviceMaintenance },
  { path: '/device-calibration/:id', component: DeviceCalibration },
  { path: '/deviceData-chart/:ids', component: DeviceDataChart },
  { path: '/device-monitor', component: DeviceMonitor },
];



// WEBPACK FOOTER //
// ./src/router/device.js